import { AutocompleteTagType } from './Tags.props';
import { Tag } from '../../../@types';
import { isString } from '../../../utils/common';

export const getSelectedExistingTagsMapped = (
  selectedTags: (AutocompleteTagType | string)[]
): Tag[] => {
  const assignedExistingTags: Tag[] = [];

  selectedTags.forEach((tag) => {
    if (!isString(tag)) {
      assignedExistingTags.push({
        id: tag.id,
        text: tag.label,
        isSystem: tag.isSystem,
        colour: tag.color,
      });
    }
  });

  return assignedExistingTags;
};

export const getNewTagsMapped = (newTags: Tag[]) => {
  return newTags.map((tag) => ({ text: tag.text, colour: tag.colour }));
};

/**
 * Maps saved tags into the shape the tag autocomplete works in.
 *
 * A missing tag list yields `[]`, not `undefined`. The optional chain here is
 * older than this comment, but the signature used to promise `AutocompleteTagType[]`
 * while the body could return `undefined` — so callers assigned the result
 * straight into state and then spread it, and TypeScript had no way to object.
 * A record served without a `tags` key took the whole page down on first paint.
 * Three call sites had grown their own `?? []`; the other nine had not.
 */
export const mapSavedTags = (savedTags?: Tag[] | null): AutocompleteTagType[] => {
  return (savedTags ?? []).map((savedTag) => ({
    id: savedTag.id,
    label: savedTag.text,
    isSystem: savedTag.isSystem,
    color: savedTag.colour,
  }));
};
